import { useQuery } from 'src/graphql';
import { CHECKLIST_QUESTION_VERSION_LAWS_QUERY } from 'src/graphql/checklistQuestion/query';

export default (id, countryId) => useQuery(CHECKLIST_QUESTION_VERSION_LAWS_QUERY, {
  variables: { id, countryId },
  fetchPolicy: 'network-only',
});
